import { MapViewport, ZOOM_THRESHOLD } from '@/constants/ui/map/mapConstants'
import { useGovernmentSettingStore } from '@/stores/governmentSettingStore'

/**
 * 現在値を取得する
 * @returns 現在地の[経度, 緯度]
 */
export const getCurrentPosition = async (): Promise<[number, number]> => {
  const governmentSettingStore = useGovernmentSettingStore()
  /** タイムアウト値 */
  const timeout = 5000
  /** デフォルトの位置（東京駅周辺） */
  const defaultPosition: [number, number] = [139.767, 35.681]

  if (!navigator.geolocation) {
    // geolocation非対応の場合は即デフォルト返す
    return defaultPosition
  }

  // 自治体設定のロケーションが設定されている場合は即返却
  const mapPosition = governmentSettingStore.initialMapLocation
  if (mapPosition && mapPosition.length >= 2) {
    return [mapPosition[0], mapPosition[1]]
  }

  return new Promise(resolve => {
    // タイムアウト時はデフォルト座標を返す
    const timerId = setTimeout(() => {
      resolve(defaultPosition)
    }, timeout)

    navigator.geolocation.getCurrentPosition(
      position => {
        clearTimeout(timerId)
        const { latitude, longitude } = position.coords
        resolve([longitude, latitude])
      },
      // 現在地の取得に失敗した場合は、エラー扱いにはせずにデフォルト座標を返す
      () => {
        resolve(defaultPosition)
      }
    )
  })
}

/**
 * ズームレベルから表示領域区分を取得する
 * @param zoom ズームレベル
 * @returns 表示領域区分
 */
export const getMapViewport = (zoom: number): MapViewport => {
  if (zoom >= ZOOM_THRESHOLD.NARROW) {
    return MapViewport.NARROW
  } else if (zoom >= ZOOM_THRESHOLD.MIDDLE) {
    return MapViewport.MIDDLE
  } else {
    return MapViewport.WIDE
  }
}
